import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import { extractDate } from "../../../Components/Functions/date.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import LoadingPage from "../../../Components/layouts/loading";
import { useState } from "react";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { titleCaseChange } from "../../../Components/Functions/changeFirstLetterUpperCase";
const tableHead = [
  "Sr.",
  "Date",
  "Business Name",
  "Craeted At",
  "Status",
  "Actions",
  "Remove",
];
const returnClassname = (isApproved) => {
  return isApproved
    ? "badge bg-success  text-white"
    : "badge bg-danger  text-white";
};
const DeliveryChallanTable = ({
  deliveries = [],
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dcList, setDcList] = useState(deliveries);

  const goToView = (id) => {
    id = getId(id);
    navigate(`/delivery-challan/view/${id}`);
  };

  const removeDc = (id) => {
    if (window.confirm("Please make sure the DC is removed")) {
      setLoading(true);

      id = getId(id);
      performRequest("DELETE", `/deliveryChallan/deleteDc/${id}`)
        .then((res) => {
          if (res.status === 200) {
            setDcList((prev) =>
              prev.filter((item) => getId(item.dcNumber) !== id),
            );
            Toast("success", "Dc Removed Successfully!");
          } else {
            Toast("error", "Error while getting data!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {dcList?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.dcNumber}>
                <td>{Index}</td>
                {/* <td>{getId(item?.dcNumber)}</td> */}
                <td>{item?.challanDate || "N/A"}</td>
                <td>
                  {titleCaseChange(item?.contactPersonName) ||
                    titleCaseChange(item?.cusClientName) ||
                    "N/A"}

                  {/* {item?.contactPersonName || item?.cusClientName || "N/A"} */}
                </td>

                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>
                  <span className={returnClassname(item?.isApproved)}>
                    {item?.isApproved ? "Approved" : "Pending"}
                  </span>
                </td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.dcNumber)}
                  ></CustomViewButton>
                </td>
                <td>
                  <button
                    className="btn btn-danger btn-sm px-3"
                    onClick={() => removeDc(item.dcNumber)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DeliveryChallanTable;
